export default function HeroMarquee() {
  const items = [
    { text: "HABILIDADES", icon: "ri-award-line" },
    { text: "GUIONES", icon: "ri-file-list-3-line" },
    { text: "SEGUIMIENTO", icon: "ri-line-chart-line" },
    { text: "DECISIONES", icon: "ri-lightbulb-line" },
    { text: "MÁS INGRESOS", icon: "ri-wallet-3-line" },
    { text: "MÁS OPORTUNIDADES", icon: "ri-briefcase-line" },
    { text: "COBRAR CON CONFIANZA", icon: "ri-shield-check-line" },
    { text: "ORGANIZAR TU DINERO", icon: "ri-pie-chart-line" },
    { text: "SIN MÍSTICA", icon: "ri-sun-line" },
    { text: "SIN HUMO", icon: "ri-cloud-off-line" },
    { text: "SOLO RESULTADOS", icon: "ri-check-double-line" },
    { text: "30 DÍAS", icon: "ri-calendar-check-line" },
  ];

  const repeated = [...items, ...items, ...items, ...items];

  return (
    <div className="relative overflow-hidden border-t border-gold/20" style={{ backgroundColor: "#0D0D0D" }}>
      <div className="flex items-center animate-marquee whitespace-nowrap py-4 md:py-5">
        {repeated.map((item, index) => (
          <span key={index} className="inline-flex items-center">
            <span
              className={`inline-flex items-center px-5 py-2.5 md:px-7 md:py-3 mx-3 md:mx-4 rounded-full font-sans text-xs md:text-sm font-semibold tracking-wider uppercase ${
                index % 2 === 0
                  ? "text-gold border border-gold/50 bg-gold/10"
                  : "text-cream border border-cream/30 bg-cream/5"
              }`}
            >
              <i className={`${item.icon} mr-1.5 text-sm md:text-base`}></i>
              {item.text}
            </span>
          </span>
        ))}
      </div>

      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee-scroll 30s linear infinite;
        }
      `}</style>
    </div>
  );
}